import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private loadingCount = 0; // counts ongoing API calls
  private _isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this._isLoading.asObservable();

  show() {
    this.loadingCount++;
    this._isLoading.next(true);
  }

  hide() {
    this.loadingCount = Math.max(0, this.loadingCount - 1);
    if (this.loadingCount === 0) {
      this._isLoading.next(false);
    }
  }

  reset() {
    this.loadingCount = 0;
    this._isLoading.next(false);
  }
}
